//import 'popper.js';
import 'bootstrap';

(function ($) {
  $(document).ready(function() {

    // Mouse Scroll
    /*$("body").on("click", ".mouse-scroll", function() {
      document.location = "#pageContent";
    });*/

     // Smooth scroll Safari
    $('body').on('click', '.mouse-scroll', function() {
      $('html, body').animate({
        scrollTop: $('#pageContent').offset().top
      });
    });

    // Sidebar Left Menu
    $("body").on("click", ".menu-burger", function() {
      $("#navbar-left").toggle(200, "swing");
    });
    $("#navbar-left").on("click", "#block-sidebarcloseicon a", function() {
      $("#navbar-left").toggle(200, "swing");
    });
    $("#navbar-left").on("click", "li.nav-item", function() {
      $("#navbar-left").toggle(200, "swing");
    });


    // Toogle menu
    $("body").on("click", ".menu-burger", function() {
      $("#submenu").toggle(200, "swing");
    });

  });

  // Cargar styles en iframe Twitter (no funciona)
  /*window.onload = function() {
    let link = document.createElement("link");
    link.href = "../../assets/css/irbradix.style.css";
    link.rel = "stylesheet";
    link.type = "text/css";
    frames[1].document.head.appendChild(link); /
  }*/

  function setTabContentLinks() {
    const tab_pane_links = document.querySelectorAll('#irbTabContent a[href^="#"]');

    tab_pane_links.forEach(link => {
      link.addEventListener('click', function (e) {
        const paneId = this.getAttribute('href'); // Esto será "#pane-X"

        const navTabLink = document.querySelector('.nav-tabs a[href="' + paneId + '"]');
        if (navTabLink) {
          navTabLink.click(); // Hacer clic en el enlace de nav-tabs
        }
      });
    });
  }

  $(document).ready(function() {

    // Generar tabs
    if ($('article > .tab').length){

      var containerTab = $( '<div></div>', { 'class': 'container', 'id': 'containerTab' });
      var irbTab = $( '<ul></ul>', {'class': 'nav nav-tabs', 'id': 'irbTab', 'role': 'tablist' });
      var irbTabContent = $( '<div></div>', { 'class': 'tab-content', 'id': 'irbTabContent' });

      $('.tab:first').before( containerTab, irbTabContent);
      $('#containerTab').append( irbTab );

      $(".tab").each(function(index){
        if ($(this).find('.block > h2').length){
          //var idTab = 'tab-'+ index;
          var idPane = 'pane-'+ index;
          var title = $(this).find('.block > h2');
          //var idTab = (title[0].innerHTML).toLowerCase().split(" ")[0];
          var idTab = (title[0].innerHTML).toLowerCase().replace(/ /g, "-");
          var navItem = $( '<li></li>', { 'class': 'nav-item' });
          var navLink = $( '<a></a>', { 'class': 'nav-link ' + idPane, 'id': idTab, 'data-toggle': 'tab', 'href': '#' + idPane, 'role': 'tab' }).text( title[0].innerHTML );
          var tabPane = $( '<div></div>', { 'class': 'tab-pane', 'id': idPane });

          $('#irbTab').append( navItem );
          $('#irbTab li:last').append( navLink );
          $('#irbTabContent').append( tabPane );

           if ($(this).next().hasClass('tab-child')) {
            var nextSiblings = $(this).nextUntil(':not(.tab-child)');
            $('#' + idPane).append(nextSiblings);
              /*var i = 0;
              while(i <= $('article > .tab-child').length){
                  if ($(this).next().hasClass('tab-child')){
                      $('#' + idPane ).append($(this).next());
                  }else{
                      break;
                  }
                  i++;
              }*/
          }
          $('#' + idPane).prepend( $(this) );
        }
      });
      $('#irbTab .nav-item:first a.nav-link').addClass('active');
      $('#irbTabContent .tab-pane:first').addClass('fade show active');

      let links = document.querySelectorAll('a[href^="#pane"]');

      if (links) {
        setTabContentLinks();
        var irbTab = document.querySelector('#containerTab');

        if (irbTab) {
          var bodyRect = document.body.getBoundingClientRect(),
          elemRect = irbTab.getBoundingClientRect(),
          offset = elemRect.top - bodyRect.top - 75;
        }

        for (var i = 0; i < links.length; i++) {
          let tab = links[i].getAttribute('href');

          if (tab == window.location.hash)
            document.querySelector('.nav-tabs a[href="' + tab + '"]').click();

          links[i].addEventListener('click', function (e) {
            document.querySelector('.nav-tabs a[href="' + tab + '"]').click();

            // Verifica si la pestaña tiene el ID "registration"
            const targetTab = document.querySelector('.basic__body a[href="' + tab + '"]');
            if (targetTab) {
              window.scrollTo({
                top: offset, // scroll so that the element is at the top of the view
                behavior: 'smooth'
              });
            }
          });
        }
      }


    }

    //Generate accordion
    if ($('article > .accordion-card').find('.block > h2').length){

      var containerCard = $( '<div></div>', { 'class': 'container', 'id': 'containerCard' });
      var irbAccordion = $( '<div></div>', { 'class': 'accordion', 'id': 'accordionPage' });

      $('.accordion-card:first').before( containerCard );
      $('#containerCard').append( irbAccordion );

      $(".accordion-card").each(function(index){

        if ($(this).find('.block > h2').length){
          $(this).removeClass('accordion-card').addClass('card');

          var idCard = 'card-'+ index;
          var idCardHeader = 'cardHeader-'+ index;
          var idCollapse = 'collapse-'+ index;
          var title = $(this).find('.block > h2');
          var cardHeader = $( '<div></div>', { 'class': 'card-header', 'id': idCardHeader });
          var cardButton = $( '<button></button>', { 'class': 'btn btn-link collapsed', 'type': 'button', 'data-toggle': 'collapse', 'data-target': '#' + idCollapse, 'aria-expanded': 'false', 'aria-controls': idCollapse }).text( title[0].innerHTML );
          title.remove();
          var divCollapse = $( '<div></div>', { 'class': 'collapse', 'id': idCollapse, 'aria-labelledby': idCardHeader, 'data-parent': '#accordionPage' });
          var cardBody = $(this).find('.container').addClass('card-body');

          if ($(this).next().hasClass('card-child')) {
              var i = 0;
              while(i <= $('.card-child').length){
                  if ($(this).next().hasClass('card-child')){
                    $(this).find('.card-body').append($(this).next());
                  }else{
                      break;
                  }
                  i++;
              }
          }

          $(this).attr( 'id', idCard);
          $(accordionPage).append( $(this));
          $('#'+idCard).append( cardHeader, divCollapse );
          $('#'+idCardHeader).append( cardButton );
          $('#'+idCollapse).append( cardBody ) ;

          $(cardButton).on('click', function () {
            setTimeout(() => {
              var offset = $(this).offset().top - 220 ; // Espacio para el panel expandido
              $('html, body').animate({
                scrollTop: offset
              }, 400);
            }, 400);
          });
        }
      });
      document.dispatchEvent(new Event('accordion:ready'));
    }





    /* Cookies policy */
    $('.eu-cookie-compliance-categories').hide();
    $("body").on("click", ".eu-cookie-compliance-show-categories-button", function() {
      $('.eu-cookie-compliance-categories').toggle();
      $(this).hide();
    });

    /* Onclick image block job openings */
    $('.dropdown-blocks .image-block__body h3' ).click(function() {
      if($(this).parent().hasClass('active')){
        $(this).parent().removeClass('active');
      }else{
        $('.dropdown-blocks .image-block__body' ).removeClass('active');
        $(this).parent().addClass('active');
      }
    });

     $('.dropdown-blocks .image-block__image').click(function () {
      if ($(this).siblings().hasClass('active')) {
        $(this).siblings().removeClass('active');
      } else {
        $('.dropdown-blocks .image-block__body').removeClass('active');
        $(this).siblings().addClass('active');
      }
    });

    $('.dropdown-blocks .content-block .block-title' ).click(function() {
      if($(this).parent().hasClass('active')){
        $(this).parent().removeClass('active');
      }else{
        $('.dropdown-blocks .content-block .block-body' ).removeClass('active');
        $(this).parent().addClass('active');
      }
    });

    /* Onclick image block alliances */
    if ($('.modal-blocks').length){
      var background = $( '<div></div>', { 'class': 'ui-widget-overlay', 'id': 'modalOverlay' });
      var closeButton = $( '<div></div>', { 'class': 'close', 'id': 'closeButton' });

      console.log('entra');

      function addElements (){
        $('.modal-blocks .content-block .block-body').append( background );
        $('.modal-blocks .content-block .block-body .linked-image-block__body').append( closeButton );
        $('.modal-blocks .content-block .block-body .card__field-body').append( closeButton );
      }

      var links = $('.linked-image-block__field-link');
      links.each(function(index){
        $(this).appendTo($(this).parent().find('.linked-image-block__body'));
      });

      $('.block-body').each(function() {
        if ($(this).text().trim() === '') {
          $(this).closest('.block-linked-image').css('cursor', 'default');
        }
      });

      $('.modal-blocks .content-block .block-title').click(function () {
        $(this).parent().addClass('active');
        if ($(this).closest('.block-linked-image').find('.ui-widget-overlay').length === 0) {
           addElements();
         }
      });

      $('.modal-blocks .content-block .card__field-title').click(function () {
        if ($(this).siblings('.block-body').text().trim() !== '') {
          $(this).parent().addClass('active');
          if ($(this).closest('.block-linked-image').find('.ui-widget-overlay').length === 0) {
            addElements();
          }
        }
      });

      $('.modal-blocks .linked-image').click(function () {
        if ($(this).parent().hasClass('paragraph--type--card')) {
           if ($(this).siblings('.content-block').find('.block-body').text().trim() === '') {
              event.preventDefault();
           } else {
              $(this).next().addClass('active');
              if ($(this).closest('.block-linked-image').find('.ui-widget-overlay').length === 0) {
                addElements();
              }
           }
        }else {
          $(this).next().addClass('active');
          if ($(this).closest('.block-linked-image').find('.ui-widget-overlay').length === 0) {
            addElements();
          }
        }
      });

      background.click(function () {
        $('.modal-blocks .content-block.active').removeClass('active');
      });

      closeButton.click(function () {
        $('.modal-blocks .content-block.active').removeClass('active');
      });
    }

  });

  $(document).ready(function(){

    // Añadir el link en el twig del bloque con more-info y less-info como texto traducible
    $('.gallery-text-link__body').addClass('collapsed');
    $('.gallery-link').on('click', function(){
      if ($(this).hasClass('more-info')){
        $(this).prev('.gallery-text-link__body').removeClass('collapsed');
        $(this).removeClass('more-info');
      }else{
        $(this).parent().find('.gallery-text-link__body').addClass('collapsed');
      $(this).addClass('more-info');
      }
    });
  });


  $(document).ready(function(){

    var maxChars = 250; // Aproximadamente 100 palabras

    var background = $( '<div></div>', { 'class': 'ui-widget-overlay', 'id': 'modalOverlay' });
    $(".masonry-layout-guinovart-submission").append(background);
    background.hide();

    function expandableTextItem(item, chars, backgroundSelector, delay) {

      var fullText = item.text();

      if (fullText.length > chars) {
        item.text(fullText.substring(0, chars) + "... ");
        var toggleButton = $('<button class="toggle-btn btn btn-link">[+]</button>');
        item.after(toggleButton);

        toggleButton.click(function () {
            if (item.hasClass('expanded')) {
              item.removeClass('expanded');
              item.parent().removeClass('selected');
              toggleButton.text("[+]");
              backgroundSelector.removeClass('active');
              if (delay) {
                setTimeout(function() {
                  item.text(fullText.substring(0, chars) + "... ");
                }, 450);
              } else {
                item.text(fullText.substring(0, chars) + "... ");
              }
              setTimeout(function() {
                backgroundSelector.hide();
                item.text(fullText.substring(0, chars) + "... ");
              }, 600);
            } else {
              item.text(fullText);
              item.addClass('expanded');
              item.parent().addClass('selected');
              toggleButton.text("✖");
              backgroundSelector.show();
              backgroundSelector.addClass('active')
              if (delay){
                $('html, body').animate({
                  scrollTop: item.first().offset().top - 200
                }, 200);
              }
            }
        });
        backgroundSelector.click(function () {
          $(this).parent().find('.selected').find('.toggle-btn').trigger("click");
        });
      }
    }

    $(".masonry-layout-guinovart-submission .masonry-item").each(function () {
      var textElement = $(this).children('.views-field-webform-submission-value-2');
      expandableTextItem(textElement, maxChars, background, false);
    });
  });


  /*
  $(document).ready(function(){

    var maxChars = 250; // Aproximadamente 100 palabras

    var background = $( '<div></div>', { 'class': 'ui-widget-overlay', 'id': 'modalOverlay' });
    $(".masonry-layout-time-capsule-submission").append(background);
    background.hide();

    function expandableTextItem(item, chars, backgroundSelector, delay) {

      var fullText = item.text();

      if (fullText.length > chars) {
        item.text(fullText.substring(0, chars) + "... ");
        var toggleButton = $('<button class="toggle-btn btn btn-link">[+]</button>');
        item.after(toggleButton);

        toggleButton.click(function () {
            if (item.hasClass('expanded')) {
              item.removeClass('expanded');
              item.parent().removeClass('selected');
              toggleButton.text("[+]");
              backgroundSelector.removeClass('active');
              if (delay) {
                setTimeout(function() {
                  item.text(fullText.substring(0, chars) + "... ");
                }, 450);
              } else {
                item.text(fullText.substring(0, chars) + "... ");
              }
              setTimeout(function() {
                backgroundSelector.hide();
                item.text(fullText.substring(0, chars) + "... ");
              }, 600);
            } else {
              item.text(fullText);
              item.addClass('expanded');
              item.parent().addClass('selected');
              toggleButton.text("✖");
              backgroundSelector.show();
              backgroundSelector.addClass('active')
              if (delay){
                $('html, body').animate({
                  scrollTop: item.first().offset().top - 200
                }, 200);
              }
            }
        });
        backgroundSelector.click(function () {
          $(this).parent().find('.selected').find('.toggle-btn').trigger("click");
        });
      }
    }

    $(".masonry-layout-time-capsule-submission .masonry-item").each(function () {
      var textElement = $(this).children('.views-field-webform-submission-value');
      expandableTextItem(textElement, maxChars, background, true);
    });

  });
  */

(function ($, Drupal) {
  Drupal.behaviors.applyExpandableText = {
    attach: function (context, settings) {
      $(context).find('.masonry-layout-time-capsule-submission').each(function () {
        // Solo a los items que aún no han sido procesados
        const maxChars = 250; // Aproximadamente 100 palabras

        const background = document.createElement('div');
        background.className = 'ui-widget-overlay';
        background.id = 'modalOverlay';

        // Añadirlo al contenedor
        var container = document.querySelector('.masonry-layout-time-capsule-submission');
        if (container) {
          container.appendChild(background);
        }

        // Ocultarlo
        background.style.display = 'none';

        var items = document.querySelectorAll('.masonry-layout-time-capsule-submission .masonry-item');

        items.forEach(function(item) {
          var textElement = item.querySelector('.views-field-webform-submission-value');
          expandableTextItem(textElement, maxChars, background);
        });
      });

      function expandableTextItem(item, chars, backgroundSelector) {

        const fullText = item.textContent;

        if (fullText.length > chars) {
          item.textContent = fullText.substring(0, chars) + "... ";

          const itemParent = item.parentNode;

          // Crear el botón
          const toggleButton = document.createElement('button');
          toggleButton.className = 'toggle-btn btn btn-link';
          toggleButton.textContent = '[+]';

          // Insertar el botón después del item
          itemParent.insertBefore(toggleButton, item.nextSibling);

          toggleButton.addEventListener('click', function () {
            if (item.classList.contains('expanded')) {
              itemParent.style.animation = 'closeModal 0.4s forwards';

              itemParent.addEventListener('animationend', function handler() {
                itemParent.removeEventListener('animationend', handler);

                // Cambiamos posición
                item.classList.remove('expanded');
                item.textContent = fullText.substring(0, chars) + "... ";
                itemParent.classList.remove('selected');
                toggleButton.textContent = "[+]";

                // Quitamos animación previa
                itemParent.style.animation = 'none';

                // Forzamos reflow para que la siguiente animación se dispare
                void itemParent.offsetWidth;

                backgroundSelector.classList.remove('active');
                backgroundSelector.addEventListener('transitionend', function handler() {
                  backgroundSelector.removeEventListener('transitionend', handler);
                  backgroundSelector.style.display = 'none';
                }, { once: true });

                // Animación de entrada
                itemParent.style.animation = 'openCard 0.3s forwards';
              }, { once: true });

            } else {
              // 1️⃣ Lanzamos animación de salida
              itemParent.style.animation = 'closeCard 0.3s forwards';
              backgroundSelector.style.display = 'block';
              void backgroundSelector.offsetWidth;
              backgroundSelector.classList.add('active');

              // 2️⃣ Cuando termina, cambiamos posición y lanzamos animación de entrada
              itemParent.addEventListener('animationend', function handler() {
                itemParent.removeEventListener('animationend', handler);

                // Cambiamos posición
                item.classList.add('expanded');
                item.textContent = fullText;
                itemParent.classList.add('selected');
                toggleButton.textContent = "✖";

                // Quitamos animación previa
                itemParent.style.animation = 'none';

                // Forzamos reflow para que la siguiente animación se dispare
                void itemParent.offsetWidth;

                // Animación de entrada
                itemParent.style.animation = 'openModal 0.4s forwards';
              }, { once: true });

            }
          });
          backgroundSelector.click(function () {
            $(this).parent().find('.selected').find('.toggle-btn').trigger("click");
          });
        }
      }
    }
  };
})(jQuery, Drupal);

  $(document).ready(function() {

    /* Open pdf in new tab */
    var pdfLinks = document.querySelectorAll('a[href$=".pdf"]');
    for (var i = 0; i < pdfLinks.length; i++){
      pdfLinks[i].setAttribute('target', '_blank');
    }


    // grupo repetido
   /* $(".tab-pane .view-research-groups .views-row span a span").filter(function() {
        return $(this).text() == 'Francesc Posas, Eulàlia De Nadal.';

    }).eq(1).parent().hide();*/

  });


  setTimeout(function(){
     let tracking = document.getElementById("pi_tracking_opt_in_yes");
     if(tracking) {tracking.click();}
    }, 6000);


  $(document).ready(function() {

    if (window.location.pathname.search("cuatro-farmacos-de-uso-comun-revierten-los-sintomas-del-alzheimer-en-ratones")>-1
    || window.location.pathname.search("quatre-farmacs-dus-comu-reverteixen-els-simptomes-de-lalzheimer-en-ratolins")>-1
    || window.location.pathname.search("four-commonly-used-medications-reverse-alzheimers-disease-mice")>-1
    ){


      const elements = document.querySelectorAll('.researcher__info');
      Array.prototype.forEach.call(elements, function(element, index) {
        var persona = element.querySelectorAll(".researcher__name a span")[0].innerHTML;
        if (persona.includes('Lidia Mateo') || persona.includes('Victor Alcalde')){
          var grupo = element.querySelectorAll(".researcher__research-group a");
          grupo[0].innerHTML = '<a href="/research/structural-bioinformatics-and-network-biology" hreflang="und">Structural Bioinformatics and Network Biology</a>'
        }
      });
    };

    /* PARECE QUE ESTO NO HACE FALTA, conservar por si acaso o como ejemplo
        //Para traducir About IRB Barcelona de las News
        if (window.location.pathname.search("news") > -1){
          var drupalLanguage = drupalSettings.path.currentLanguage;
          var newsBasicBlocksH2 = document.querySelectorAll(".body-text-news .block--basic h2");
          Array.prototype.forEach.call(newsBasicBlocksH2, function(block, index) {
            if (block.innerHTML.includes("About IRB Barcelona")){
              if (drupalLanguage == "es"){
                block.textContent = "Sobre el IRB Barcelona";
              }else if(drupalLanguage == "ca"){
                block.textContent = "Sobre l’IRB Barcelona";
              }
            };
          });
        };
    */

  });

  $(document).ready(function() {

    // Añade la clase caption para que la imagen tenga bien los estilos

    var figure = document.querySelectorAll(".figure");

    if (figure) {
      $(figure).removeClass("figure");
      $(figure).addClass("caption");
    }

  });

  //---------------- FLoating Button ----------------//

  var $buttonScroll = $("#buttonScroll");
  var $circleanimation = $('#encapsulate');
  var $buttonDonate = $('#buttonDonate');
  var $encapsulate = $('#encapsulate');
  var amountScrolled = 300;
  var finalScrolled = 1600;
  var heightMax = $(window).height() - (100);

  $(window).scroll(function () {

    if ($(window).scrollTop() > amountScrolled) {
      $buttonScroll.css('transform', 'scale(1)');
      //   $buttonDonate.css({'bottom': '0px'});
      $circleanimation.css('transition', 'all 0.3s', 'slow')
      $circleanimation.css('transform', 'scale(0.65)');
      $encapsulate.css({
        'left': '-35px'
      });
      $circleanimation.css({
        'bottom': '0px'
      });
    } else {
      $buttonScroll.css('transform', 'scale(1)');
      // $buttonDonate.css({'bottom': '11px'});
      $circleanimation.css('transition', 'all 0.3s', 'slow')
      $circleanimation.css('transform', 'scale(1)');
      $encapsulate.css({
        'left': '0%'
      });
      $circleanimation.css({
        'bottom': '11px'
      });
    }
    if ($(window).scrollTop() > finalScrolled) {
      $buttonScroll.fadeOut('slow');
      $buttonDonate.fadeOut('slow');
    } else {
      $buttonScroll.fadeIn('slow');
      $buttonDonate.fadeIn('slow');
    }
  });

  $('a.back-to-top, a.simple-back-to-top').click(function () {
    $('html, body').animate({
      scrollTop: 0
    }, 700);
    return false;
  });

  // Overlay de búsqueda. Los disparadores son <button>, así que se pueden usar
  // con teclado; aquí mantenemos sincronizado su aria-expanded y el foco.
  const SEARCH_TOGGLE = '.search-icon .nav-btn';
  let lastSearchToggle = null;

  function openSearchOverlay(toggle) {
    const overlay = document.getElementById('searchOverlay');
    if (!overlay) {
      return;
    }
    overlay.classList.remove('hide');
    overlay.classList.add('show');
    lastSearchToggle = toggle;
    if (toggle) {
      toggle.setAttribute('aria-expanded', 'true');
    }
    const input = document.getElementById('edit-s');
    if (input) {
      input.focus();
    }
  }

  function closeSearchOverlay() {
    const overlay = document.getElementById('searchOverlay');
    if (!overlay) {
      return;
    }
    overlay.classList.remove('show');
    overlay.classList.add('hide');
    // Devolvemos el foco al botón que abrió el overlay.
    const toggle = lastSearchToggle || document.querySelector(SEARCH_TOGGLE);
    if (toggle) {
      toggle.setAttribute('aria-expanded', 'false');
      toggle.focus();
    }
  }

  document.addEventListener('click', function (e) {
    if (!(e.target instanceof Element)) {
      return;
    }
    const toggle = e.target.closest(SEARCH_TOGGLE);
    if (toggle) {
      e.preventDefault();
      openSearchOverlay(toggle);
      return;
    }
    if (e.target.closest('#searchOverlay .nav-close .nav-btn')) {
      e.preventDefault();
      closeSearchOverlay();
    }
  });

  // Escape cierra el overlay, como se espera de un diálogo.
  document.addEventListener('keydown', function (e) {
    const overlay = document.getElementById('searchOverlay');
    if (e.key === 'Escape' && overlay && overlay.classList.contains('show')) {
      closeSearchOverlay();
    }
  });


  let player = $('.background-video--wrapper video');
  if (player.length > 0) {
    if (window.innerWidth > 768) {
      player.prop("autoplay", true);
      player[0].play();
    }
  }

})(jQuery, Drupal);
/*https://irb3.ddev.site/researcg/research-programmes?tid=9*/

window.onload = function() {
  // Verificar si hay un hash en la URL
  const hash = window.location.hash;
  if (hash && hash.startsWith("pane")) {
    // Esperar a que el navegador haya renderizado el contenido
    setTimeout(function() {
      const targetElement = document.querySelector(hash);
      if (targetElement) {
        targetElement.scrollIntoView({
          behavior: 'smooth',
          block: 'start' // Esto asegura que el elemento quede alineado en la parte superior
        });
        // Ajustar el desplazamiento adicional con margin-top manualmente
        window.scrollBy(0, -60); // Desplazar hacia arriba 60px para compensar el margen
      }
    }, 100); // Ajusta el tiempo si es necesario
  }
};

(function (Drupal) {
  Drupal.behaviors.dialogOverlayCloseFix = {
    attach() {
      document.addEventListener('click', function (e) {
        if (e.target.classList.contains('ui-widget-overlay')) {
          document.querySelectorAll('.ui-dialog-content').forEach(function (dialog) {
            jQuery(dialog).dialog('close');
          });
        }
      });
    }
  };
})(Drupal);
